import React from 'react';
import { FiStar, FiEdit2 } from 'react-icons/fi';
import { GoTrash } from 'react-icons/go';
import { FaRegBuilding } from "react-icons/fa";

const ReviewCard = ({ review, onEdit, onDelete, onToggleStatus }) => {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-200 dark:border-slate-800 p-6 flex flex-col hover:shadow-md transition-shadow relative">
      <div className="flex justify-between items-start mb-4">
        <div className="h-12 w-12 bg-gray-100 dark:bg-slate-800 rounded-lg flex items-center justify-center overflow-hidden shrink-0">
          {review.companyLogo ? (
            <img src={review.companyLogo} alt={review.companyName} className="w-full h-full object-contain p-1" />
          ) : (
            <FaRegBuilding className="w-6 h-6 text-gray-400" />
          )}
        </div>
        
        <div className="flex gap-2">
          <button onClick={() => onEdit(review)} className="p-2 text-gray-400 hover:text-primary hover:bg-primary/10 rounded-lg transition-colors">
            <FiEdit2 className="w-4 h-4" />
          </button>
          <button onClick={() => onDelete(review)} className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 rounded-lg transition-colors">
            <GoTrash className="w-4 h-4" />
          </button>
        </div>
      </div>

      <p className="text-gray-600 dark:text-gray-300 text-sm flex-grow mb-6 italic line-clamp-4">
        "{review.reviewNotes}"
      </p>

      <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-100 dark:border-slate-800">
        <div className="h-10 w-10 bg-primary/10 rounded-full flex items-center justify-center text-primary font-bold overflow-hidden shrink-0">
          {review.name?.charAt(0).toUpperCase() || '?'}
        </div>
        <div className="flex-grow min-w-0">
          <h3 className="text-sm font-semibold text-gray-900 dark:text-white truncate">{review.name}</h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
            {review.designation}{review.designation && review.companyName ? ' at ' : ''}{review.companyName}
          </p>
        </div>
        <div className="flex flex-col items-end shrink-0">
          <div className="flex text-yellow-400 text-xs">
            {[...Array(5)].map((_, i) => (
              <FiStar key={i} className={i < review.rating ? "fill-current" : "text-gray-300 dark:text-slate-600"} />
            ))}
          </div>
          {review.isActive !== undefined && (
            <button 
              onClick={() => onToggleStatus(review)}
              className="mt-1 hover:opacity-80 transition-opacity focus:outline-none"
              title="Click to toggle status"
            >
              <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${
                review.isActive 
                  ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' 
                  : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400'
              }`}>
                {review.isActive ? 'Active' : 'Inactive'}
              </span>
            </button>
          )}
 
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
